import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './List.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { EmptyFolderHighDefinition } from 'blaze-ui/icons/nonStandard/EmptyFolderHighDefinition'
import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import { WizardsDrawer } from 'components/Wizards/WizardsDrawer/WizardsDrawer'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'

export const ListEmptyState = () => {
  const { drawersStore } = useRootStore()
  const { currentFolder } = useCurrentFolderStore()

  return (
    <div className={Styles.listEmptyState}>
      <div className={Styles.icon}>
        <EmptyFolderHighDefinition />
      </div>
      <div className={Styles.text}>
        <Heading level={3}>This project is empty</Heading>
        <Text color="var(--dark-80)">
          <div className={Styles.content}>Here you will be able to see everything in this project</div>
        </Text>
      </div>
      <div>
        <Button
          frontIcon={Plus}
          size="lg"
          onPress={() => drawersStore.openDrawer(WizardsDrawer, { initialValues: { project: currentFolder } })}
        >
          Create New
        </Button>
      </div>
    </div>
  )
}
